// Define a default UI for filtering in Grid
export function DefaultColumnFilter({column: {filterValue, setFilter}}) {
    return (
        <input
            value={filterValue || ""}
            onChange={(e) => {
                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
            }}
            placeholder={`Search`}
            style={{width: "100%"}}
        />
    );
}